export const createDefaultTemplate = (id, { wrapperClass, buttonTheme = 'filled-secondary', backgroundTheme = 'default' }) => {
  return (
    `<section
      class="ui-modal ui-modal--${backgroundTheme}"
      id="${id}"
    >
      <div
        class="${wrapperClass || ''}"
        data-element="content-wrapper"
      >
        <button
          class="
            ui-modal__close
            ui-icon-button
            ui-icon-button--${buttonTheme}
            ui-icon-button--small
            ui-icon-button--circle
          "
          type="button"
          aria-label="Закрыть модальное окно"
        >
          <svg
            width="20"
            height="20"
            aria-hidden="true"
            class="ui-icon-button__icon ui-icon-button__icon--small"
          >
            <use href="#ui-close"/>
          </svg>
        </button>
      </div>
    </section>`
  )
}
